import Leaflet from 'leaflet';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Marker } from 'react-leaflet';
import { useDispatch } from 'react-redux';

import { commitMarker } from '../../redux/actions';
import MarkerPopup from '../marker-popup';

const MapEditableMarkerComponent = React.memo(({ Icon, background, data }) => {
  const { latlng, region } = data;
  const color = (region && background) || '#000000';

  const dispatch = useDispatch();

  const DOMString = useMemo(
    () =>
      ReactDOMServer.renderToString(
        <div className="is-relative">
          <div className="is-absolute">
            <Icon background={color} />
          </div>
        </div>
      ),
    [color]
  );

  const dragendHandler = useCallback(
    ({ target }) => {
      const coords = target.getLatLng();
      const next = { ...data, latlng: coords };
      dispatch(commitMarker(next));
    },
    [data, dispatch]
  );

  const dragstartHandler = useCallback(() => {}, []);

  return (
    <Marker
      draggable
      eventHandlers={{
        dragend: dragendHandler,
        dragstart: dragstartHandler,
      }}
      icon={Leaflet.divIcon({
        className: 'leaflet-div-icon',
        html: DOMString,
      })}
      position={latlng}>
      <MarkerPopup data={data} />
    </Marker>
  );
});

MapEditableMarkerComponent.propTypes = {
  Icon: PropTypes.shape().isRequired,
  background: PropTypes.string.isRequired,
  data: PropTypes.shape({
    category: PropTypes.string,
    id: PropTypes.string,
    latlng: PropTypes.shape(),
    region: PropTypes.string,
  }).isRequired,
};

MapEditableMarkerComponent.displayName = 'MapEditableMarkerComponent';

export default MapEditableMarkerComponent;
